import {
  CampaignFilter,
  EventFilterTypeEnum
} from 'front-end/src/graphql/private/PrivateSchemaTypes'
import React, { FC } from 'react'
import { plural, t, Trans } from '@lingui/macro'
import {
  useEventNameQuery,
  useRecurringEventNameQuery
} from 'front-end/src/pages/manage-campaign-page/components/campaign-audience/filter-humanizers/EventInvitationFilterHumanizer.codegen'
import { getEventStatusOptionsMap } from 'front-end/src/pages/manage-campaign-page/components/campaign-audience/CampaignAudienceHelpers'

const EventName: FC<{ id: number }> = ({ id }) => {
  const { data, loading } = useEventNameQuery({
    // TODO: without no-cache it does not work and returning undefined all the time.
    // Definitely worth investigating.
    fetchPolicy: 'no-cache',
    variables: { eventId: id }
  })
  if (loading) {
    return null
  }

  return data?.admin?.event?.title
}

const RecurringEventName: FC<{ id: number }> = ({ id }) => {
  const { data, loading } = useRecurringEventNameQuery({
    // TODO: without no-cache it does not work and returning undefined all the time.
    // Definitely worth investigating.
    fetchPolicy: 'no-cache',
    variables: { eventId: id }
  })
  if (loading) {
    return null
  }

  return data?.admin?.recurringEvent?.title
}

export const EventInvitationFilterHumanizer: FC<CampaignFilter> = (filter) => {
  const status = filter.eventFilterSetup?.eventFilterType as EventFilterTypeEnum

  const eventIds = filter.eventFilterSetup?.eventIds
  const recurringEventIds = filter.eventFilterSetup?.recurringEventIds

  const totalEventsCount =
    (eventIds?.length || 0) + (recurringEventIds?.length || 0)

  if (totalEventsCount === 0) {
    return null
  }

  const eventPlural = plural(eventIds?.length || 0, {
    one: 'event',
    other: 'events'
  })

  return (
    <>
      <Trans>
        Event invitation status is {getEventStatusOptionsMap()[status]} in
      </Trans>{' '}
      {totalEventsCount < 3 ? (
        <>
          {eventIds?.map((id, i) => {
            return (
              <strong key={`reg-${id}`}>
                {i > 0 && ', '}
                <EventName id={id} />
              </strong>
            )
          })}
          {eventIds &&
            eventIds?.length > 0 &&
            ` ${eventPlural} ${
              recurringEventIds && recurringEventIds?.length > 0 ? t`and` : ''
            } `}

          {recurringEventIds?.map((id, i) => {
            return (
              <strong key={`rec-${id}`}>
                {i > 0 && ', '}
                <RecurringEventName id={id} />
              </strong>
            )
          })}
          {recurringEventIds &&
            recurringEventIds?.length > 0 &&
            ` ${t`event series`}`}
        </>
      ) : (
        `${
          eventIds && eventIds?.length > 0
            ? `${eventIds?.length} ${eventPlural}  ${
                recurringEventIds && recurringEventIds?.length > 0 ? t`and` : ''
              }`
            : ``
        }
            ${
              recurringEventIds && recurringEventIds?.length > 0
                ? `${recurringEventIds?.length} ${t`event series`}`
                : ''
            }`
      )}
    </>
  )
}
